module.exports = __webpack_public_path__ + "img/thomas-desfossez-2019.fc904797.jpg";